
























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class MainLayout extends Vue {
    @Prop({
        default: true
    })
    isSidebarVisible!: boolean;
}
